import { CustomersScreen } from '../features/customers/CustomersScreen'
import { useShell } from '../app/outlet'

export function CustomersPage() {
  const { toast } = useShell()
  return <CustomersScreen onToast={toast} />
}
